<!--
  Rendered inside the Settings screen's "Issue tracker" tab, which supplies the
  heading. Kept as its own component: it has its own loading, saving and error
  states, and folding those into the host would make one component that does two
  unrelated jobs.
-->
<div class="mt-3">

  @if (loading) {
    <p class="text-muted">{{'ISSUE.LOADING' | translate}}</p>
  } @else {
    <div class="row">
      <div class="col-12 col-lg-8">

        <!--
          Where the keys come from. Without this an administrator is looking at
          two password boxes with no way to know what belongs in them, which is
          how the screen read before.
        -->
        <div class="card mb-4">
          <div class="card-body">
            <h6 class="card-title">{{'ISSUE.SETTINGS.HOW_TITLE' | translate}}</h6>
            <ol class="mb-2 ps-3">
              <li>{{'ISSUE.SETTINGS.HOW_STEP_1' | translate}}</li>
              <li>{{'ISSUE.SETTINGS.HOW_STEP_2' | translate}}</li>
              <li>{{'ISSUE.SETTINGS.HOW_STEP_3' | translate}}</li>
            </ol>
            <p class="mb-0 small text-muted">{{'ISSUE.SETTINGS.HOW_NOTE' | translate}}</p>
          </div>
        </div>

        <div class="alert" [class.alert-success]="settings?.configured"
             [class.alert-warning]="!settings?.configured" role="alert">
          @if (settings?.configured) {
            {{'ISSUE.SETTINGS.CONFIGURED' | translate}} <code>{{settings?.hint}}</code>
            @if (settings?.readConfigured) {
              <div class="small mt-1">
                {{'ISSUE.SETTINGS.READ_CONFIGURED' | translate}} <code>{{settings?.readHint}}</code>
              </div>
            } @else if (settings?.readUsesSubmitKey) {
              <div class="small mt-1">{{'ISSUE.SETTINGS.READ_USES_SUBMIT' | translate}}</div>
            }
            @if (settings?.source === 'environment') {
              <div class="small mt-1">{{'ISSUE.SETTINGS.FROM_ENVIRONMENT' | translate}}</div>
            }
            @if (settings?.updatedBy) {
              <div class="small mt-1">
                {{'ISSUE.SETTINGS.UPDATED_BY' | translate}} {{settings?.updatedBy}}
                @if (settings?.updatedAt) { — {{settings?.updatedAt | date:'yyyy-MM-dd HH:mm'}} }
              </div>
            }
          } @else {
            {{'ISSUE.SETTINGS.NOT_CONFIGURED' | translate}}
          }
        </div>

        <div class="mb-3">
          <label class="form-label" for="trackerBaseUrl">{{'ISSUE.SETTINGS.BASE_URL' | translate}}</label>
          <input id="trackerBaseUrl" class="form-control" type="url"
                 [(ngModel)]="baseUrl" name="baseUrl" autocomplete="off"
                 placeholder="https://issues.syciety.com">
          <div class="form-text">{{'ISSUE.SETTINGS.BASE_URL_HELP' | translate}}</div>
        </div>

        <div class="mb-3">
          <label class="form-label" for="trackerApiKey">{{'ISSUE.SETTINGS.API_KEY' | translate}}</label>
          <input id="trackerApiKey" class="form-control" type="password"
                 [(ngModel)]="apiKey" name="apiKey" autocomplete="new-password"
                 [attr.placeholder]="'ISSUE.SETTINGS.API_KEY_PLACEHOLDER' | translate">
          <div class="form-text">{{'ISSUE.SETTINGS.API_KEY_HELP' | translate}}</div>
        </div>

        <div class="mb-2">
          <label class="form-label" for="trackerReadApiKey">{{'ISSUE.SETTINGS.READ_API_KEY' | translate}}</label>
          <input id="trackerReadApiKey" class="form-control" type="password"
                 [(ngModel)]="readApiKey" name="readApiKey" autocomplete="new-password"
                 [attr.placeholder]="'ISSUE.SETTINGS.READ_API_KEY_PLACEHOLDER' | translate">
          <div class="form-text">{{'ISSUE.SETTINGS.READ_API_KEY_HELP' | translate}}</div>
        </div>

        <div class="d-flex flex-wrap gap-2 mt-3">
          <button type="button" class="btn btn-primary" [disabled]="saving" (click)="save()">
            {{'ISSUE.SETTINGS.SAVE' | translate}}
          </button>
          @if (settings?.configured && settings?.source === 'settings') {
            <button type="button" class="btn btn-outline-danger" [disabled]="saving" (click)="clearKey()">
              {{'ISSUE.SETTINGS.CLEAR' | translate}}
            </button>
          }
        </div>

      </div>
    </div>
  }
</div>
